module.exports = __webpack_public_path__ + "media/images/crypto-currencies/raiblocks-20b91a25ae4226b0582825aa4541239e.svg";